import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChoiceGroup, Label, Stack } from '@fluentui/react';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { getPriorityOptions } from './index';

export const CampaignPriority = ({
  data, onDataChange, activity, i18n, ...restProps
}) => {
  const { campaign } = data;
  const [priority, setPriority] = useState(campaign.Priority || 'Low');
  const onCampaignPriorityChange = useCallback((ev, option) => {
    activity.signal(`onCampaignPriorityChange: ${option.key}`);
    setPriority(option.key);
  }, [activity]);

  useEffect(() => {
    if (campaign.Priority !== priority) {
      onDataChange({
        data: {
          ...data,
          campaign: { ...data.campaign, Priority: priority },
        },
      });
    }
  }, [campaign.Priority, data, onDataChange, priority]);

  return (
    <div className="campaign-priority-container">
      <Label id="CampaignPriority">
        <Stack horizontal verticalAlign="center">
          <span>{i18n.getString(_TL_('Campaign priority'))}</span>
          <HelpPopup topic="pop_BA_BSC_CampPri" />
        </Stack>
      </Label>
      <ChoiceGroup
        selectedKey={priority}
        options={getPriorityOptions(i18n)}
        onChange={onCampaignPriorityChange}
        ariaLabelledBy="CampaignPriority"
        {...restProps}
      />
    </div>
  );
};

CampaignPriority.propTypes = {
  data: PropTypes.shape({
    campaign: PropTypes.shape({
      Priority: PropTypes.string,
    }),
  }).isRequired,
  onDataChange: PropTypes.func.isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
